import {useSyncExternalStore} from 'react';

function detectIsMac() {
  if (typeof navigator === 'undefined') return null;

  return /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
}

export function useIsMac() {
  return useSyncExternalStore(
    () => () => {},
    detectIsMac,
    () => null,
  );
}
